import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-boolean-display',
  standalone: false,
  templateUrl: './boolean-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./boolean-display.component.scss'],
})
export class BooleanDisplayComponent {
  @Input() value: boolean | undefined;
}
